var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isFullScreen)?[_c('CardTarjaTVZFullScreen',{attrs:{"item":_vm.item,"hideUserInfo":_vm.hideUserInfo,"flgExibirUf":_vm.flgExibirUf}})]:[_c('CardTarjaTVZComments',{attrs:{"item":_vm.item,"posicao-card":_vm.posicaoCard,"hide-user-info":_vm.hideUserInfo,"flg-exibir-uf":_vm.flgExibirUf}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }